export const getRapportAar = new Date().getUTCFullYear();
export default getRapportAar;
